const TopBar = {
  setSwiperTopBar: function () {
    const topBar = document.querySelector('[data-top-bar]');

    if (topBar) {
      const slider = new Swiper(topBar, {
        slidesPerView: 1,
        preloadImages: false,
        speed: 1000,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        lazy: {
          checkInView: true,
          loadPrevNext: true,
          loadOnTransitionStart: true,
          loadPrevNextAmount: 4,
        },
      });

      //Autoplay condicional
      slider.autoplay.stop();

      const eventType = window.mobile ? 'scroll' : 'mousemove';
      window.addEventListener(eventType, slider.autoplay.start, { once: true });
    }
  },

  init: function () {
    const _this = this;

    _this.setSwiperTopBar();
  },
};

export default TopBar;
